
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {dataFieldsEditModule} from "@/store";
import DataFieldCache from "@/models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {formatDate} from "@/auxillary/date-format";
import {stringify} from "@/auxillary/datafield.stringify";
import Hints from "@/components/study/datafields/base/Hints.vue";

@Component({
  name: 'DateField',
  components: {
    DataFieldBar,
    OkDialog,
    Hints
  },
})
export default class DateField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  errorMessage: string = "";
  menu = false;

  get formattedValue(){
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : formatDate(this?.dataField?.values?.value);
  }

  get value() {
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : value
  }

  set value(value: string) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
  }

  updateValue() {
    let value = "";
    if (this.unknown && this.canBeUnknown)
      value = "unknown";
    this.value = value;
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  set unknown(value: boolean) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "unknown", value})
    this.updateValue()
  }

  get isVisible(){
    return this.field.isVisible;
  }

  get isReadonly(){
    return !this.field.isEditable;
  }

  get field() {
    return this.dataField;
  }

  get width() {
    // TODO needs better dynnamic width
    return (this.displayName.length+5) * 12;
  }

  get displayName(){
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName + (this.isRequired ? "<span style='color:red;'>*</span>" : "");
  }

  get isRequired(){
    return this.dataField.isRequired
  }

}
